import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Owned } from 'app/model/base/named';

import { DataFlowSink } from '../dataflow/dataflow-sink';

@Metamodel.model({
    name: 'PowerQuerySink',
    referable: true
})
export class PowerQuerySink extends Owned {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({})
    public queryName: string;

    @Metamodel.attribute({
        display: stringResources.Sink,
        type: DataFlowSink.MODEL
    })
    public sinks: DataFlowSink[];

    constructor(queryName: string, sinks: DataFlowSink[]) {
        super();
        this.queryName = queryName;
        this.sinks = sinks;
    }
}
